import React from "react"
import tw, { theme } from "twin.macro"
import { createGlobalStyle } from "styled-components"

// ROOT === Light
// These default values get loaded when there is not a specific theme set
// They are the NEW Bonsai styles
// Setting the theme to "light" is the same thing as setting the default.

export const SystemColorTokens = createGlobalStyle({
  ":root": {
    // Common color tokens
    "--white": "#FFFFFF",
    "--black": "#000000",
    "--transparent": "transparent",

    // System Color Tokens ========
    // Grey scale
    "--system-gray-1": "#EDEEEF",
    "--system-gray-2": "#E3E3E3",
    "--system-gray-3": "#C6C6C6",
    "--system-gray-4": "#AAAAAA",
    "--system-gray-5": "#8E8E8E",
    "--system-gray-6": "#555555",
    "--system-gray-7": "#393939",
    "--system-gray-8": "#1C1C1C",
    "--system-gray-9": "#000000",

    // Pink scale
    "--system-pink-1": "#FCCAEB",
    "--system-pink-2": "#F8A9DA",
    "--system-pink-3": "#F589CA",
    "--system-pink-4": "#F168B9",
    "--system-pink-5": "#ED47A8",
    "--system-pink-6": "#CD3E92",
    "--system-pink-7": "#AE347B",
    "--system-pink-8": "#8E2B65",
    "--system-pink-9": "#6E214E",

    // Purple scale
    "--system-purple-1": "#E7D1FA",
    "--system-purple-2": "#DCACF9",
    "--system-purple-3": "#D288F9",
    "--system-purple-4": "#C763F8",
    "--system-purple-5": "#BC3EF7",
    "--system-purple-6": "#9A31D1",
    "--system-purple-7": "#7723AB",
    "--system-purple-8": "#551685",
    "--system-purple-9": "#32085F",

    // Lime scale
    "--system-lime-1": "#EEF9D9",
    "--system-lime-2": "#EBF6B6",
    "--system-lime-3": "#E9F393",
    "--system-lime-4": "#E6EF6F",
    "--system-lime-5": "#E3EC4C",
    "--system-lime-6": "#C5CD42",
    "--system-lime-7": "#A7AD38",
    "--system-lime-8": "#888E2D",
    "--system-lime-9": "#6A6E23",

    // blue scale
    "--system-blue-1": "#BFEEFF",
    "--system-blue-2": "#A8E8FF",
    "--system-blue-3": "#A0E0FC",
    "--system-blue-4": "#79DBFF",
    "--system-blue-5": "#61D5FF",
    "--system-blue-6": "#56C9F2",
    "--system-blue-7": "#4BBDE6",
    "--system-blue-8": "#40B0D9",
    "--system-blue-9": "#35A4CC",

    // green scale
    "--system-green-1": "#E7FDDD",
    "--system-green-2": "#7FE250",
    "--system-green-3": "#2B501A",

    // red scale
    "--system-red-1": "#FFC6C6",
    "--system-red-2": "#F84D4D",
    "--system-red-3": "#812323",

    "--test-magenta": "#ff87b2",
    "--test-indigo": "#967efb",
    "--test-blue": "#58b4ff",
    "--test-mint": "#0ceda6",
    "--test-green": "#98d035",
    "--test-gold": "#ffbe2e",
    "--test-orange": "#fa9441",
    "--test-red": "#ff8d7b",
  },
})

export const ThemeColorTokens = createGlobalStyle({
  // New Theme color tokens
  ":root": {
    "--background": theme(`colors.white`),
    "--modal": theme(`colors.white`),
    "--overlay": "rgba(28, 28, 28, 0.25)",
    "--body-color": theme(`colors.base-5`),
    "--link-color": theme(`colors.purple`),
    "--logo-color": theme(`colors.base-6`),

    "--input": theme(`colors.white`),

    "--base-6": theme(`colors.system-gray-8`),
    "--base-5": theme(`colors.system-gray-7`),
    "--base-4": theme(`colors.system-gray-5`),
    "--base-3": theme(`colors.system-gray-3`),
    "--base-2": theme(`colors.system-gray-2`),
    "--base-1": theme(`colors.system-gray-1`),
    "--pink": theme(`colors.system-pink-5`),
    "--light-pink": theme(`colors.system-pink-1`),
    "--dark-pink": theme(`colors.system-pink-7`),
    "--purple": theme(`colors.system-purple-5`),
    "--light-purple": theme(`colors.system-purple-1`),
    "--inactive-purple": theme(`colors.system-purple-2`),
    "--hover-purple": theme(`colors.system-purple-7`),
    "--dark-purple": theme(`colors.system-purple-9`),
    "--lime": theme(`colors.system-lime-5`),
    "--light-lime": theme(`colors.system-lime-1`),
    "--blue": theme(`colors.system-blue-5`),
    "--dark-blue": theme(`colors.system-blue-9`),
    "--green": theme(`colors.system-green-2`),
    "--dark-green": theme(`colors.system-green-3`),
    "--light-green": theme(`colors.system-green-1`),
    "--red": theme(`colors.system-red-2`),
    "--dark-red": theme(`colors.system-red-3`),
    "--light-red": theme(`colors.system-red-1`),
  },

  // DARK Theme colors
  "[data-theme='dark']": {
    "--background": theme(`colors.base-6`),
    "--modal": theme(`colors.base-6`),
    "--overlay": theme(`colors.white`),
    "--body-color": theme(`colors.white`),
    "--link-color": theme(`colors.purple`),
    "--logo-color": theme(`colors.white`),
    "--input": theme(`colors.white`),
  },
})
